/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import type { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Photos',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9.075 4.539c-1.106 0-2.003.897-2.003 2.003s.897 2.003 2.003 2.003 2.003-.897 2.003-2.003-.897-2.003-2.003-2.003zm-.903 2.003c0-.499.404-.903.903-.903s.903.404.903.903-.404.903-.903.903-.903-.404-.903-.903zm-5.623-3.93a1.55 1.55 0 0 0-1.55 1.55v7.676a1.55 1.55 0 0 0 1.55 1.55H13.45a1.55 1.55 0 0 0 1.55-1.55V4.162a1.55 1.55 0 0 0-1.55-1.55H2.549zm-.45 1.55a.45.45 0 0 1 .45-.45H13.45a.45.45 0 0 1 .45.45v5.496l-1.07-1.071a1.05 1.05 0 0 0-1.485 0l-2.196 2.196-4.387-4.387a1.05 1.05 0 0 0-1.485 0L2.099 7.574V4.162zm7.102 8.126h4.249a.45.45 0 0 0 .45-.45v-.624L12.087 9.4l-2.886 2.888zM4.019 7.21l5.078 5.078H2.549a.45.45 0 0 1-.45-.45V9.13l1.92-1.92z"
          />
        </>
      ),
    },
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M14.017 6.673A2.62 2.62 0 0 0 11.4 9.29a2.62 2.62 0 0 0 2.617 2.617 2.62 2.62 0 0 0 2.617-2.617 2.62 2.62 0 0 0-2.617-2.617zM12.6 9.29a1.42 1.42 0 0 1 1.417-1.417 1.42 1.42 0 0 1 1.417 1.417 1.42 1.42 0 0 1-1.417 1.417A1.42 1.42 0 0 1 12.6 9.29zM3.098 3.599a2.1 2.1 0 0 0-2.1 2.1v12.603a2.1 2.1 0 0 0 2.1 2.1h17.803a2.1 2.1 0 0 0 2.1-2.1V5.699a2.1 2.1 0 0 0-2.1-2.1H3.098zm-.9 2.1a.9.9 0 0 1 .9-.9h17.803a.9.9 0 0 1 .9.9v8.399l-2.257-2.257a1.35 1.35 0 0 0-1.909 0l-3.784 3.784-7.316-7.316a1.35 1.35 0 0 0-1.909 0l-2.428 2.428V5.699zm11.699 11.67l-8.21-8.211a.15.15 0 0 0-.212 0l-3.276 3.276v5.867a.9.9 0 0 0 .9.9h17.803a.9.9 0 0 0 .9-.9v-2.506l-3.105-3.105a.15.15 0 0 0-.212 0l-4.587 4.679z"
          />
        </>
      ),
    },
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M18.235 9.35a3.211 3.211 0 1 0 0 6.423 3.211 3.211 0 0 0 0-6.423zm-2.011 3.211a2.012 2.012 0 0 1 4.023 0 2.012 2.012 0 1 1-4.023 0zM4.096 5.347a2.1 2.1 0 0 0-2.1 2.1v17.106a2.1 2.1 0 0 0 2.1 2.1h23.809a2.1 2.1 0 0 0 2.1-2.1V7.447a2.1 2.1 0 0 0-2.1-2.1H4.096zm-.9 2.1a.9.9 0 0 1 .9-.9h23.809a.9.9 0 0 1 .9.9v12.058l-2.897-2.897a2 2 0 0 0-2.828 0L18.386 21.3l-9.244-9.244a2 2 0 0 0-2.828 0l-3.118 3.118V7.447zm15.208 15.569L8.293 12.905a.8.8 0 0 0-1.131 0l-3.966 3.966v7.682a.9.9 0 0 0 .9.9h23.809a.9.9 0 0 0 .9-.9v-3.352l-3.745-3.745a.8.8 0 0 0-1.131 0l-5.523 5.56z"
          />
        </>
      ),
    },
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M27.396 14.498c-2.178 0-3.982 1.71-3.982 3.866s1.804 3.866 3.982 3.866 3.982-1.71 3.982-3.866-1.804-3.866-3.982-3.866zm-2.732 3.866c0-1.424 1.202-2.616 2.732-2.616s2.732 1.192 2.732 2.616-1.202 2.616-2.732 2.616-2.732-1.192-2.732-2.616zM5.124 8.623c-1.174 0-2.125.951-2.125 2.125v26.504c0 1.174.951 2.125 2.125 2.125h37.751c1.174 0 2.125-.951 2.125-2.125V10.748c0-1.174-.951-2.125-2.125-2.125H5.124zm-.875 2.125c0-.483.392-.875.875-.875h37.751c.483 0 .875.392.875.875v18.686l-4.952-4.781a2.74 2.74 0 0 0-3.777 0l-7.395 7.138-14.313-13.817a2.74 2.74 0 0 0-3.777 0l-5.287 5.104v-12.33zm23.4 22.802L12.414 18.843c-.546-.527-1.432-.527-1.979 0l-6.186 5.972v12.437c0 .483.392.875.875.875h37.751c.483 0 .875-.392.875-.875v-6.08l-5.852-5.65c-.546-.527-1.432-.527-1.979 0l-8.272 8.028z"
          />
        </>
      ),
    },
    '64': {
      viewBox: '0 0 64 64',
      path: (
        <>
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M36.229 20.145c-2.724 0-4.981 2.139-4.981 4.836s2.257 4.836 4.981 4.836 4.981-2.139 4.981-4.836-2.257-4.836-4.981-4.836zm-3.381 4.836c0-1.761 1.487-3.236 3.381-3.236s3.381 1.475 3.381 3.236-1.487 3.236-3.381 3.236-3.381-1.475-3.381-3.236zM8.123 12.828a2.3 2.3 0 0 0-2.3 2.3v33.746a2.3 2.3 0 0 0 2.3 2.3h47.753a2.3 2.3 0 0 0 2.3-2.3V15.128a2.3 2.3 0 0 0-2.3-2.3H8.123zm-.7 2.3a.7.7 0 0 1 .7-.7h47.753a.7.7 0 0 1 .7.7v23.59l-6.484-6.259c-1.113-1.074-2.916-1.074-4.029 0l-9.547 9.216-18.163-17.534c-1.113-1.074-2.916-1.074-4.029 0l-6.901 6.662V15.128zM36.529 43.91L17.202 25.252c-.477-.46-1.25-.46-1.727 0l-8.052 7.773v15.848a.7.7 0 0 0 .7.7h47.753a.7.7 0 0 0 .7-.7V40.94l-7.635-7.371c-.477-.46-1.25-.46-1.727 0l-10.686 10.34z"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
